import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import CheckboxInput from '@/components/Base/Forms/Inputs/CheckboxInput.vue';
export default defineComponent({
    name: 'filter-newly-arrived',
    components: {
        CheckboxInput,
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        appliedFilters: 'appliedFilters',
    })), { newlyArrived: {
            get: function () {
                return this.appliedFilters.newlyArrived;
            },
            set: function (newlyArrived) {
                this.setNewlyArrived(newlyArrived.checked);
            },
        } }),
    methods: Object.assign({}, mapActions('blue', {
        setNewlyArrived: 'SET_NEWLY_ARRIVED_ONLY',
    })),
});
